import axios from '@/libs/api.request'
// 更新配置
export const manageUpdate = data => {
    return axios.request({
      url: '/manage/update',
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'post',
      data,
    })
  }
  // 系统配置
export const manageVariables = data => {
    return axios.request({
      url: '/manage/variables',
      method: 'post',
      data,
    })
  }